module.exports = __webpack_public_path__ + "a768e7de/img/verified-icon.f93bbc14.svg";